import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import { useWindowSize } from "@hooks/useWindowSize";
import HighlightsLead from "@pages/Keyword/customPages/BTSG60Page/components/Highlights/HighlightsLead";
import HighlightsSide from "@pages/Keyword/customPages/BTSG60Page/components/Highlights/HighlightsSide";
import HighlightsSubLead from "@pages/Keyword/customPages/BTSG60Page/components/Highlights/HighlightsSubLead";
import PDFDownload from "@pages/Keyword/customPages/BTSG60Page/components/Highlights/PDFDownload";
import Card from "@particles/card/Card";
import { cn } from "@util/helpers";

type HighlightsProps = {
  /** This is the classname of the component. */
  className?: string;
  /** List of card props to be displayed. */
  cardProps: ComponentProps<typeof Card>[];
  /** Link to the PDF Download */
  pdfDownload: string | null;
};

/** The highlights component in BT SG 60 page.
 * https://www.figma.com/design/50gwyNfDsv70dHaddmTd7k/BT-SG60--WEB---APP-?node-id=164-79049&m=dev
 */
const Highlights = ({
  className,
  cardProps,
  pdfDownload,
}: HighlightsProps): React.ReactElement => {
  const { isScreenXL } = useWindowSize();

  if (cardProps.length === 0) return <></>;

  return (
    <div data-testid="highlights-component" className={className}>
      <BlockTitle text="HIGHLIGHTS" rootClassName="mb-4" />

      <Row rootClassName="-mx-4">
        <Column rootClassName="w-full xl:w-2/3 px-4">
          <HighlightsLead cardProp={cardProps[0]} className="mb-8" />

          <HighlightsSubLead
            cardProps={cardProps.slice(1, isScreenXL ? 9 : 13)}
            className="mb-8"
          />
        </Column>

        <Column
          rootClassName={cn(
            "w-full xl:w-1/3 px-4 relative",
            "xl:before:absolute xl:before:left-0 xl:before:h-full xl:before:w-[1px] xl:before:bg-gray-175"
          )}
        >
          <HighlightsSide cardProps={cardProps.slice(9, 15)} className="mb-8" />

          {pdfDownload ? <PDFDownload link={pdfDownload} /> : null}
        </Column>
      </Row>
    </div>
  );
};

export default Highlights;
